import { jsx as t } from "@emotion/react/jsx-runtime";
import { TextInput as i } from "@partoohub/ui";
import { SelectButtonContainer as l } from "./SelectButton.styled.js";
const c = ({
  dataTrackId: e,
  buttonText: r,
  label: o,
  disabled: n = !1,
  onClick: a
}) => /* @__PURE__ */ t(l, { onClick: a, "aria-disabled": n, children: /* @__PURE__ */ t(i, { dataTrackId: e, label: o, value: r, readOnly: !0 }) });
export {
  c as SelectButton
};
